module.exports = __webpack_public_path__ + "static/img/12.f04e5e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/12.png
// module id = Ol3N
// module chunks = 0